import React from "react";
import RegisterForm from "../../components/Auth/RegisterForm";
import PageLayout from "../../components/PageLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { CountryCode } from "../../utils/Constants";

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const from = state?.from || '/';

  // Extract values from state
  const { phoneNumber, countryCode: countryCodeString } = location.state || {};

  // Convert string to CountryCode enum if possible
  const countryCode = countryCodeString ?
    (Object.values(CountryCode).includes(countryCodeString) ? countryCodeString as CountryCode : CountryCode.HONG_KONG) :
    CountryCode.HONG_KONG;

  React.useEffect(() => {
    // Check if phoneNumber is empty/null and redirect if needed
    if (!phoneNumber) {
      navigate(from, {
        replace: true,
        state: {
          ...(location.state || {}),
          toastMessage: 'Registration requires phone number',
          toastMode: 'warning',
        }
      });
    }
  }, [navigate, from, location.state, phoneNumber]);

  return (
    <PageLayout isLogin={true}>
      {/*<p>Registering: +{countryCode} {phoneNumber}</p>*/}
      <RegisterForm phoneNumber={phoneNumber} countryCode={countryCode} />
    </PageLayout>
  );
};

export default RegisterPage;